// Angular
import { Injectable } from '@angular/core';
// External
import { AngularFireDatabase } from 'angularfire2/database';
import { Subscription } from 'rxjs/Subscription';
import * as lodash from 'lodash';

@Injectable()

export class ElasticService {

  private key: string;
  private subscription: Subscription;

  constructor(private fireDatabase: AngularFireDatabase) {
  }

  public search(queryParams: Object): Promise<any> {
    return new Promise((resolve, reject) => {

      const key = this.fireDatabase.database.ref('/search/request/').push().key;
      this.fireDatabase.object(`/search/request/${key}`).update(queryParams);

      const subscription = this.fireDatabase.list(`/search/response/${key}`)
        .subscribe(result => {
          const hitsIndex = lodash.findIndex(result, 'hits');

          if (hitsIndex !== -1) {
            this.fireDatabase.object(`/search/response/${key}`).remove();

            resolve(result[hitsIndex]);

            subscription.unsubscribe();
          } else {
            if (result[1]) {
              if (result[1].total == 0) {
                resolve(null)

              }
            }

          }

        }, error => {
          reject(error);
        });
    });
  }
}
